import request from "@/utils/request";

// export const postUpdatePassword = async <T>(data: any) => {
//   return await request.post<any, T>("/api/amazwear-system/user/update-password", data, {
//     params: { ...data },
//     paramsSerializer: serialize,
//   });
// };

/** 获取用户信息 */
export const postUserInfo = async <T>() => {
  return await request.post<any, T>("/api/amazwear-user/app/user/userInfo");
};

/** 获取邮箱验证码 */
export const postQueryEmailCaptcha = async <T>(data: any) => {
  return await request.post<any, T>("/api/amazwear-user/public/user/sendVerificationCode", data);
};

/** 邮箱登录 */
export const postQueryEmailLogin = async <T>(data: any) => {
  return await request.post<any, T>("/api/amazwear-user/public/user/login", data);
};